import createReactComponent from '../createReactComponent';
export default createReactComponent('equal-double', 'IconEqualDouble', [
  ['path', { d: 'M3 10h7', key: 'svg-0' }],
  ['path', { d: 'M3 14h7', key: 'svg-1' }],
  ['path', { d: 'M14 10h7', key: 'svg-2' }],
  ['path', { d: 'M14 14h7', key: 'svg-3' }],
]);
